import React from 'react';
import { CheckboxV2Props } from '@withjoy/joykit';
import { StyledCheckbox, styles } from './Checkbox.styles';
import { ReactComponent as IconSvg } from './checkbox.svg';

interface CheckboxProps extends CheckboxV2Props {
  isChecked?: boolean;
  isDisabled?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = props => {
  const { isChecked = false, isDisabled, ...restProps } = props;

  return (
    <StyledCheckbox
      overrides={{
        Control: {
          props: styles.checkboxControl,
        },
        Icon: {
          component: IconSvg,
        },
      }}
      isChecked={isChecked}
      isDisabled={isDisabled}
      {...restProps}
    />
  );
};
